// import store from '../vuex/store'
import router from './index'
import NProgress from 'nprogress/nprogress'
import store from '../vuex/store'

let requestsTotal = 0
let requestsCompleted = 0
// Number of ms before progressbar starts showing, 100 is default
let latencyThreshold = 100
// Number of ms after response to finish progress bar
let responseLatency = 50

const setComplete = () => {
  requestsTotal = 0
  requestsCompleted = 0
  NProgress.done()
}

const interceptor = (request, next) => {
  if (!request.url.includes('webmaniabr')) {
    if (!store.getters.getCompany.api && store.getters.getUser.api) {
      request.headers.set('Authorization', `Bearer: ${store.getters.getUser.api}`)
    } else if (store.getters.getCompany.api) {
      request.headers.set('Authorization', `Bearer: ${store.getters.getCompany.api}`)
    }
  }

  if (requestsTotal === 0) {
    if (latencyThreshold === 0) {
      NProgress.start()
    } else {
      setTimeout(() => {
        if (requestsTotal !== requestsCompleted) {
          NProgress.start()
        }
      }, latencyThreshold)
    }
  }
  requestsTotal++

  next((response) => {
    if (response.status === 0 || response.status === null) {
      response.status = 400
      response.statusText = 'Bad Request'
      if (response.body === '' || response.body === null) {
        response.body = {
          message: 'Erro ao conectar ao serviço de back-end. \nProcure o suporte!'
        }
      }
    } else {
      if (response.status >= 400 && (response.body === null || response.body === '')) {
        response.body = {
          message: 'Requisição não concluída. \nProcure o suporte!'
        }
      }
    }

    setTimeout(() => {
      requestsCompleted++

      if (requestsCompleted >= requestsTotal) {
        setComplete()
      }
    }, responseLatency)

    if (response.status === 403 || response.status === 401) {
      store.dispatch('setUser', null)
      store.dispatch('setCompany', null)
      router.push({ name: 'Login' })
    }
    return response
  })
}

export default interceptor



// WEBPACK FOOTER //
// ./src/router/interceptor.js